// extracted by mini-css-extract-plugin
export default {"hidden":"nUfS08","container":"kvjnZ8","controls-showed":"zC5gtm","controlsShowed":"zC5gtm"};